import styled, { keyframes } from 'styled-components';
import { IStyledTestIdProps } from '../../utils';

export const StyledMainContainer = styled.div`
    border: 1px solid ${({ theme }) => theme.gray8};
    border-radius: 8px;
    margin: 10px;
    margin-bottom: 20px;
`;

export const StyledActionsContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    width: 100%;
    @media (max-width: 768px) {
        flex-direction: column;
        padding-bottom: 0px;
        gap: 5px;
    }
`;

export const StyledContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 20px;
    gap: 10px;
    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 10px;
    }
`;

export const StyledList = styled.ul`
    padding: 0;
    list-style: none;
`;

export const StyledListItem = styled.li`
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
`;

export const StyledLabel = styled.span<IStyledTestIdProps>`
    margin: 0;
`;

export const StyledValue = styled.span<IStyledTestIdProps>`
    margin: 0;
    color: ${({ theme }) => theme.gray3};
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const StyledCardContainer = styled.div`
    #modal-wrapper {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
        width: 100%;
        padding: 20px;
        animation: ${fadeIn} 0.5s ease-in-out;

        @media (max-width: 768px) {
            grid-template-columns: repeat(1, 1fr);
            gap: 10px;
        }
    }
`;

export const StyledEventValue = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.gray3};
`;

export const StyleSsapApplicantEvent = styled.div`
    padding: 0px 20px 20px 20px;

    @media (max-width: 768px) {
        padding: 10px 10px 20px 10px;
    }
`;

export const StyledCoverage = styled.li`
    padding-bottom: 10px;
`;
